<template>
  <div>
    <Header :title="title" :showBack="true"></Header>

    <div style="margin: 16px; padding: 20px">
      <van-button round block type="danger" @click="clearRedis">
        清除所选缓存
      </van-button>
    </div>

    <van-checkbox-group v-model="result">
      <van-cell-group>
        <van-cell
          v-for="(item, index) in list"
          clickable
          :key="item.cacheName"
          :title="item.cacheDisplayName"
          @click="toggle(index)"
        >
          <template #right-icon>
            <van-checkbox :name="item.cacheName" ref="checkboxes" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "缓存管理", //页面标题
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员对象
      result: [
        "API_StartNodeQuery",
        "API_ArrivalNodeQuery",
        "API_LineClassDayLineSaleQuery",
        "API_LineClassDaySaleQuery",
        "API_LineClassDayMinPriceQuery",
      ],
      list: [
        { cacheName: "API_StartNodeQuery", cacheDisplayName: "上车点查询缓存" },
        {
          cacheName: "API_ArrivalNodeQuery",
          cacheDisplayName: "下车点查询缓存",
        },
        { cacheName: "API_LineQuery", cacheDisplayName: "线路查询缓存" },

        {
          cacheName: "API_LineClassDayLineSaleNewQuery",
          cacheDisplayName: "实时班次售票查询(线路)缓存",
        },
        {
          cacheName: "API_LineClassDaySaleNewQuery",
          cacheDisplayName: "线路日班次查询缓存",
        },
        {
          cacheName: "API_LineClassDayMinPriceQuery",
          cacheDisplayName: "每天的最低价和余位查询缓存",
        },
        {
          cacheName: "WX_CompanyInfoQuery",
          cacheDisplayName: "微信系统参数查询缓存",
        },
        {
          cacheName: "WX_InsuranceProductQuery",
          cacheDisplayName: "保险产品查询缓存",
        },
        {
          cacheName: "WX_NodeVillageQuery",
          cacheDisplayName: "楼巴小区查询缓存",
        },
        {
          cacheName: "WX_TicketOrderDetailMapDataQuery",
          cacheDisplayName: "微信订单详情查询缓存",
        },
        {
          cacheName: "WX_VillageLineClassDayQuery",
          cacheDisplayName: "楼巴线路日班次查询缓存",
        },
        {
          cacheName: "WX_VillageLineClassQuery",
          cacheDisplayName: "楼巴线路班次查询缓存",
        },
        {
          cacheName: "WX_VillageLineQuery",
          cacheDisplayName: "楼巴线路查询缓存",
        },
        { cacheName: "SysUserAuthToken", cacheDisplayName: "用户会话" },
        { cacheName: "other", cacheDisplayName: "其它" },
      ],
    };
  },
  watch: {},
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    clearRedis() {
      this.$dialog
        .confirm({
          title: "操作确认",
          message: "此操作将会清除所选择的微信前端查询缓存，是否确认？",
        })
        .then(() => {
          //查询选择的缓存 RedisCacheQuery
          this.$http
            .post(
              this.$api.RedisCacheQuery,
              this.$qs.stringify({
                AgentAppIDList: this.$utils.getSysParams(
                  "WindowSaleAgentAppID"
                ),
                CompGIDList: JSON.parse(
                  window.localStorage.getItem("adminInfo")
                ).CompGID,
                CacheTypeList: this.result.toString(),
                ReverseSearch: false,
              })
            )
            .then((res) => {
              if (res.length > 0) {
                var CacheNameList = [];
                res.forEach((item) => {
                  CacheNameList.push(item.CacheName);
                });
                this.$http
                  .post(
                    this.$api.RedisCacheDelete,
                    this.$qs.stringify({
                      CacheNameList: CacheNameList.toString(),
                    })
                  )
                  .then((res2) => {
                    if (res2.success) {
                      this.$toast("缓存清除成功");
                    } else {
                      this.$dialog.alert({
                        title: "提示",
                        message: res2.msg,
                      });
                    }
                  });
              } else {
                this.$dialog.alert({
                  title: "提示",
                  message: "没有查询到可以清除的缓存",
                });
              }
            });
        })
        .catch(() => {});
    },
  },
  mounted: function() {},
  created() {},
};
</script>

<style scoped lang="less"></style>
